// extracted by mini-css-extract-plugin
export var textInput = "_hx-0";